// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d1e07a55","455":"c919e140","977":"82873506"}[chunkId] + ".chunk.js";
};